import { v4 as uuidv4 } from 'uuid';

export const links = [
  {
    id: uuidv4(),
    url: '/',
    text: 'home',
  },
  {
    id: uuidv4(),
    url: '/gallery',
    text: 'photos',
  },
  {
    id: uuidv4(),
    url: '/models',
    text: 'models',
  },
  {
    id: uuidv4(),
    url: '/appointment',
    text: 'appointment',
  },
  {
    id: uuidv4(),
    url: '/faq',
    text: 'faq',
  },
  {
    id: uuidv4(),
    url: '/contact',
    text: 'contact',
  },
];
